import imagesLoaded from 'imagesloaded';
import Isotope from 'isotope-layout';

import { modalsStopVideo } from './main.js';

const layout = document.querySelectorAll('[data-isotope]');
const filter = document.querySelectorAll('[data-filter]');

//selected filter for request arrange
var currFilter = '*';

// filtration
filter.forEach(function (element) {
    element.addEventListener("click", () => {
        const value = element.dataset.filter;
        const target = element.dataset.target;
        const siblings = element.parentNode.querySelectorAll('button');
        // add current filter to var
        currFilter = value;

        for (var i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove('current');
        }
        element.classList.add('current');

        Isotope.data(target).arrange({
            filter: value,
        })
    })
})


// layout
layout.forEach(function (element) {
    imagesLoaded(element, function () {
        new Isotope(element);
    });
})

/* Videos - Request load */
const videoLoadBtn = document.getElementById('load_video');
const iso_element = document.querySelector('.filter-container'); 

// load more items
if (videoLoadBtn) {

    videoLoadBtn.addEventListener('click', function( event ) {
        var iso_general = new Isotope(iso_element, {
          layoutMode: 'fitRows'
        });
        var offset = videoLoadBtn.dataset.offset;
        var new_offset = parseInt(offset)+12;

        // filter items - load items
        var loadUrl = '/home/apps/videos/',
            resultContainer = document.getElementById('filter_wrap'),
            httpRequest = new XMLHttpRequest();

        // response
        httpRequest.onreadystatechange = function () {
          if (httpRequest.readyState === 4) {
            // add new html
            var dataHtml = httpRequest.response;
            resultContainer.innerHTML += dataHtml;

            iso_general.insert(dataHtml);
            // re-init iso, with filter
            iso_general = new Isotope(iso_element, {
                    layoutMode: 'fitRows'
                });
            iso_general.arrange({ filter: currFilter });
            // update offset if more videos
            if (resultContainer.children.length < new_offset) {
                videoLoadBtn.classList.add('d-none');
            } else {
                videoLoadBtn.setAttribute('data-offset', new_offset);
            }
            var video_modals = document.querySelectorAll('.video-modal');
            /* stop video on modal close - new elements */
            modalsStopVideo(video_modals);
          }
        };

        // request
        httpRequest.open('POST', loadUrl, true);
        httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        httpRequest.send('offset=' + encodeURIComponent(offset));
        //httpRequest.send('offset=' + encodeURIComponent(offset)+'&filterid='+ encodeURIComponent(itemID));
    });
}